export default "/_next/static/media/SourceSansProExtraLight.19929b5c91f346b763585d3a0a01062b.woff2";